jQuery(function($){
  initWorksPopin($);
});

function initWorksPopin($){
  $('.work-teaser__popin-open').on('click', function(){
    var slideId = $(this).data('id');
    var items = [];
    $('.work-popin').each(function () {
      if ($(this).data('id') == slideId) {
        items.push({ src: $(this) });
      }
    });

    $.magnificPopup.open({
      items: items,
      gallery: {
        // enabled: true
      }
    }, 0);
  });
}
